import { ToggleButton as Bs5ToggleButton } from 'react-bootstrap5';

export default Bs5ToggleButton;
